import { ItemBar } from "components/ItemBar";
import { ToastContext } from "context/ToastContext";
import { prepareCodesForSubmit, RangeTooLargeError } from "helpers/codeRanges";
import { Button } from "primereact/button";
import { useContext, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useCreatePackageRulesetMutation } from "store/queries/packageRuleset";

import {
  mapPackagesFormToRequestBody,
  getRulesetList,
} from "../helpers/mapFormToRequestBody";

export function SubmitPackages() {
  const {
    getValues,
    formState: { isValid },
  } = useFormContext();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [createPackageRuleset] = useCreatePackageRulesetMutation();

  const { current: toastElement } = useContext(ToastContext);

  const createPayerRule = async () => {
    const values = getValues();
    let triggerCptCodes: string[];
    let bundledCptCodes: string[];
    try {
      triggerCptCodes = prepareCodesForSubmit(values.triggerCptCodes ?? []);
      bundledCptCodes = prepareCodesForSubmit(values.bundledCptCodes ?? []);
    } catch (err) {
      toastElement?.show({
        severity: "error",
        summary: "Range too large",
        detail:
          err instanceof RangeTooLargeError
            ? err.message
            : "Failed to expand code ranges",
      });
      return;
    }
    const rulesToCreateRaw = getRulesetList(
      { ...values, triggerCptCodes, bundledCptCodes },
      false
    );
    const rulesToCreate = rulesToCreateRaw.map((rule) => {
      return mapPackagesFormToRequestBody(rule);
    });
    setLoading(true);
    try {
      const results = await Promise.all(
        rulesToCreate.map((rule) =>
          createPackageRuleset(rule)
            .unwrap()
            .catch(() => false)
        )
      );
      const allSuccessful = results.every((result) => result !== false);
      if (allSuccessful) {
        toastElement?.show({
          severity: "success",
          summary: "Package Rule(s) created",
          detail: "Package Rule(s) created successfully",
        });
        setLoading(false);
        navigate("/payer-rules");
      } else {
        toastElement?.show({
          severity: "error",
          summary: "Error",
          detail:
            "An error has occurred attempting to create one or more package rulesets",
        });
        setLoading(false);
        navigate("/payer-rules");
      }
    } catch (error) {
      toastElement?.show({
        severity: "error",
        summary: "Error",
        detail: "An error has occurred",
      });
      setLoading(false);
    }
  };
  return (
    <ItemBar>
      <div
        data-testid="submit__Hospital"
        className="flex flex-1 justify-content-end"
      >
        <Button
          label="Create Package Rule"
          onClick={createPayerRule}
          disabled={!isValid}
          loading={loading}
        />
      </div>
    </ItemBar>
  );
}
